import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cb9fea3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-data-box w-100 d-flex flex-column align-items-center justify-content-center py-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-48px",
  src: "media/svg/custom/empty_data.svg"
}, null, -1))
const _hoisted_3 = { class: "mt-4 text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("common.noData")), 1)
  ]))
}